import Vue from "vue"

import App from "./App.vue"
import VueMaterial from "vue-material"
import ElementUI from "element-ui"
import VueGlobalVariable from "vue-global-var"
import VueApexCharts from "vue-apexcharts"
import VCalendar from "v-calendar"

import locale from "element-ui/lib/locale/lang/it"
import VueTreeList from "vue-tree-list"
//import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import Vuex from "vuex"
import axios from "axios"
import { FocusTrap } from "focus-trap-vue"

import router from "./router/router"
import { i18n } from "./plugins/i18n.js"
import { parsingAxiosError } from "@/utils/error"
import { goto, notification, processError, iOS } from "@/utils/utils"

// MODULE STORE
import userStore from "@/modules/user/user-store"
import organizationStore from "@/modules/organization/organization-store"
import mailStore from "@/modules/mail/mail-store"
import moduleStore from "@/modules/modules-store"
import subscriptionStore from "@/modules/datas/subscriptions/subscription-store"
import PaymentStore from "@/modules/users/payments/payments-store"
import SettingStore from "@/modules/setting/setting-store"
import DocumentStore from "@/modules/documents/documents-store"
import VariableStore from "./modules/datas/variables/variables-store"
import DataStore from "@/modules/datas/datas-store"
import floStore from "@/modules/flowcharts/flowchart-store"
import compilationStore from "@/modules/flowcharts/compilation-store"
import builderStore from "@/modules/builder/builder-store"
import builderObjectStore from "@/modules/builder/builder-obj-store.js"
import UsersStore from "@/modules/users/users-store"
import SchoolStore from "@/modules/users/schools/schools-store"
import DashboardStore from "@/modules/dashboard/dashboard-store"
import ProsemirrorStore from "@/modules/prosemirror/prosemirror-store"
import ProjectStore from "@/modules/projects/project-store"
import TicketingStore from "@/modules/ticketing/ticketing-store"
import WizardStore from "@/modules/wizard/wizard-store"

import moment from "moment-timezone"
import momentTZ from "moment-timezone"
import "moment/locale/it"

import "vue-material/dist/vue-material.css"
import "vue-material/dist/theme/default.css"
import "./assets/scss/material-kit.scss"
import "./assets/scss/material-dashboard.scss"
import "element-ui/lib/theme-chalk/index.css"
import "./assets/scss/my-dialog.scss"

Vue.config.productionTip = process.env.NODE_ENV === "production"

Vue.config.keyCodes = {
	at: 59
}

Vue.prototype.$goTo = goto
Vue.prototype.$axios = axios

let globalData = new Vue({
	data: { $module: undefined }
})

Vue.mixin({
	computed: {
		$module: {
			get: function () {
				return globalData.$data.$module
			},
			set: function (newModule) {
				globalData.$data.$module = newModule
			}
		}
	}
})
Vue.component("FocusTrap", FocusTrap)
Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.use(VueMaterial)
Vue.use(ElementUI, { locale })
Vue.use(VueTreeList)
Vue.use(Vuex)
Vue.use(VueApexCharts)
Vue.use(VCalendar)
Vue.component("apexchart", VueApexCharts)

// se ci sono problemi di timezone in produzione, provare a contrallare la timezone del sistema con timedatectl

moment.updateLocale("it", "it")
moment.tz("Europe/Rome").format()
// moment.tz.setDefault("Europe/Rome");

Vue.prototype.moment = moment

//Vue.component('font-awesome-icon', FontAwesomeIcon)
var _ = require("lodash")
const store = new Vuex.Store({
	modules: {
		user: userStore,
		organization: organizationStore,
		modules: moduleStore,
		subscription: subscriptionStore,
		payment: PaymentStore,
		setting: SettingStore,
		documents: DocumentStore,
		data: DataStore,
		users: UsersStore,
		school: SchoolStore,
		variable: VariableStore,
		flowchart: floStore,
		builder: builderStore,
		object: builderObjectStore,
		dashboard: DashboardStore,
		prose: ProsemirrorStore,
		project: ProjectStore,
		compilation: compilationStore,
		ticketing: TicketingStore,
		wizard: WizardStore
	}
})

Vue.use(VueGlobalVariable, {
	globals: {
		$parsingAxiosError: parsingAxiosError,
		$processError: processError,
		$notification: notification
	}
})

if(!iOS())
	Notification.requestPermission()

new Vue({
	el: "#app",
	render: h => h(App),
	router,
	i18n,
	store,
	created: function () {
		store.dispatch("modules/doSettings")
	}
})
